import { IViewRefusalCountSinceLastConsumptionModel } from '../interfaces/';

export class ViewRefusalCountSinceLastConsumptionModel implements IViewRefusalCountSinceLastConsumptionModel {
    AnimalName: string;
    AnimalId: string;
    Count: number;    
	MaxConsumedDate: Date;
}


// WEBPACK FOOTER //
// ./src/app/models/ViewRefusalCountSinceLastConsumptionModel.ts